<template>
  <div class="full-size">
    <div style="width:100%;height:50%" class="flex-block-center">
      <div style="width:90%;height:90%;display:flex;flex-direction: column">
        <div class="flex-grow-1" style="width:100%">
          <textarea
            v-model="text"
            ref="text"
            class="text grey-border"
            placeholder="Type your text message here..."
            @change="change"
          ></textarea>
        </div>

        <div
          style="padding:10px;background-color: white;opacity: .5;border-radius: 0 0 5px 5px"
          class="grey-border"
        >
          {{ unsubTxt }}
        </div>
        <div class="ui-text pa-2 text-center pb-0">
          Chars: {{ charCount }} {{ segments }}
        </div>
      </div>
    </div>
    <hi-row style="width:100%;height:50%" grow class="shadow-behind bg-white">
      <i-phone-message :message="previewText"></i-phone-message>
    </hi-row>
  </div>
</template>

<script>
import IPhoneMessage from "@/components/sms/IPhoneMessage";
import HiRow from "@/components/scaffold/HiRow";

export default {
  name: "SmsEditor",
  components: { HiRow, IPhoneMessage },
  data() {
    return {
      // charCount: 0,
      text: "",
      unsubTxt: "Reply STOP to opt out."
    };
  },
  props: {
    value: {
      type: String
    },
    campaign: {
      type: String
    }
  },
  methods: {
    change() {
      this.$emit("input", this.text + "\n" + this.unsubTxt);
    }
    // updateCharCount() {
    //   this.charCount = this.text.trim().length + this.unsubTxt.length;
    // }
  },
  computed: {
    charCount() {
      this.$emit("input", this.text + "\n" + this.unsubTxt);
      return this.text.trim().length + this.unsubTxt.length;
    },
    previewText() {
      if (!this.text || !this.text.length) {
        return this.unsubTxt;
      }
      return this.text + "\n" + this.unsubTxt;
    },
    segments() {
      if (this.charCount < 160) return "in 1 segment";
      else {
        return `in ${Math.ceil(this.charCount / 153)} segments`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .text {
  width: 100%;
  height: 100%;
  border-radius: 5px 5px 0 0;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  opacity: 0.6;
  transition: opacity 0.5s;
  resize: none;
}
::v-deep .grey-border {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
::v-deep .text:focus {
  outline: none;
  opacity: 1;
}
</style>
